export const FORM = {
    VALUE: {
        required: "Bedrag is hier verplicht",
        pattern: {
            value: /^(0|[1-9]\d*)$/,
            message: "Bedrag moet een heel getal zijn"
        },
        validate: {
            minimum: value =>
                parseInt(value, 10) >= 5 || "Bedrag kan minimaal € 5 zijn",
            maximum: value =>
                parseInt(value, 10) <= 150 || "Bedrag kan maximaal € 150 zijn"
        }
    },
    QUANTITY: {
        required: "Aantal is hier verplicht",
        pattern: {
            value: /^(0|[1-9]\d*)$/,
            message: "Aantal mag alleen een nummer zijn"
        }
    }
};
